/* eslint-disable no-use-before-define */
import React from 'react'
import { NO_RESULT_ICON } from '../../twd'
export default ({msg}) => <div
    className="text-muted text-center">
        {NO_RESULT_ICON}
        <br/>
        <h5 className="subhead">{msg}</h5>
    </div>